import React from "react";

export function Card(props) {
  const { children, className = "", ...rest } = props;

  return (
    <div className={`border rounded-lg shadow-md ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader(props) {
  const { children, className = "", ...rest } = props;

  return (
    <div className={`p-4 border-b ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function CardTitle(props) {
  const { children, className = "", ...rest } = props;

  return (
    <h2 className={`text-xl font-semibold ${className}`} {...rest}>
      {children}
    </h2>
  );
}

export function CardContent(props) {
  const { children, className = "", ...rest } = props;

  return (
    <div className={`p-4 ${className}`} {...rest}>
      {children}
    </div>
  );
}
